import { API, graphqlOperation } from "aws-amplify";
import { ISaleStatRepository } from "./saleStat.types";
import * as queries from "@/graphql/queries";
import { Stat } from "@/entities";
import dayjs from "dayjs";

export class SaleStatAPIRepository implements ISaleStatRepository {
    async getSaleStat(
        id: string,
        granularityTimestamp?: any,
        nextToken?: string
    ): Promise<Stat[]> {
        const result = (await API.graphql({
            ...graphqlOperation(queries.saleStatByGranularityAndTimestamp, {
                id,
                granularityTimestamp,
                nextToken,
                // limit: 1,
            }),
            ...{
                authMode: "AMAZON_COGNITO_USER_POOLS",
            },
        })) as any;

        // console.log(result.data.saleStatByGranularityAndTimestamp);

        return result.data.saleStatByGranularityAndTimestamp;
    }
    async refreshDailyStat(): Promise<void> {
        const result = await API.post("saletoolapi", "/stat/branch/daily", {
            body: {
                date: dayjs().format("YYYY-MM-DD"),
            },
        });
        console.log({ result });
        return;
    }
}
